module.exports = __webpack_public_path__ + "img/banner-princiapal.7878f269.svg";